import axiosInstance from '../helpers/axiosInstance'

export const createPickingOrder = async data => {
  const res = await axiosInstance.post(`${process.env.REACT_APP_PLATFORM_URL}/api/v1/picking-order`, data)
  return res.data
}

export const previewPickingOrder = async (orders, pickerIds) => {
  const res = await axiosInstance.post(`${process.env.REACT_APP_PLATFORM_URL}/api/v1/picking-order/preview`, { orders, picker_ids: pickerIds })
  return res.data
}

export const reassignPickingOrder = async data => {
  const res = await axiosInstance.patch(`${process.env.REACT_APP_PLATFORM_URL}/api/v1/picking-orders/reassign-picker`, data)
  return res.data
}

// One call resolves what the packer scanned. Answers { kind: 'tote', picking_order } or
// { kind: 'stockless_order', order_id }; a refusal comes back as a 404/409/422 with a code.
export const scanPackingCode = async (scannedCode, warehouseId, sortBy) => {
  try {
    const res = await axiosInstance.post(`${process.env.REACT_APP_PLATFORM_URL}/api/v1/packing/scan`, {
      scanned_code: scannedCode,
      warehouse_id: warehouseId,
      ...(sortBy ? { sort_by: sortBy } : {}),
    })
    return res.data
  } catch (error) {
    // Temporary: a 404 with no `code` means the route itself is missing (platform not
    // deployed yet, or rolled back), so fall back to the tote lookup this screen used
    // before. Remove it once the scan endpoint is deployed everywhere.
    if (error?.response?.status !== 404 || error.response.data?.code) throw error
    try {
      const res = await axiosInstance.get(`${process.env.REACT_APP_PLATFORM_URL}/api/v1/picking-orders/tote/${encodeURIComponent(scannedCode)}`, {
        params: { warehouse_id: warehouseId, sort_by: sortBy },
      })
      return { kind: 'tote', picking_order: res.data }
    } catch (legacyError) {
      if (legacyError?.response?.status === 404) {
        throw { response: { status: 404, data: { code: 'SCAN_NOT_FOUND' } } }
      }
      throw legacyError
    }
  }
}

export const fetchSipSiblingByProduct = async (pickingOrderId, productSkuUpc, exclude_picking_order_id = null) => {
  const params = {
    product_upc_sku: productSkuUpc,
    exclude_picking_order_id: exclude_picking_order_id,
  }
  const res = await axiosInstance.get(`${process.env.REACT_APP_PLATFORM_URL}/api/v1/picking-orders/${pickingOrderId}/sip-sibling-by-product`, { params })
  return res.data
}

// CUBBO-2182: lists the orders still pending packing in the picking order's tote
// (cross-SKU), so the SIP product-scan view can show "what's left in this tote".
// Backed by platform PR #3605. Returns { tote_id, picking_orders: [...] }.
export const fetchSipTotePending = async pickingOrderId => {
  const res = await axiosInstance.get(`${process.env.REACT_APP_PLATFORM_URL}/api/v1/picking-orders/${pickingOrderId}/sip-tote-pending`)
  return res.data
}

// `payload` carries the supervisor's choice: { picker_id, assignments? }. picker_id is required
// by the backend and owns any remainder task the optional per-location assignments don't name.
export const undoPickingOrderInReview = async (pickingOrderId, payload) => {
  const res = await axiosInstance.post(`${process.env.REACT_APP_PLATFORM_URL}/api/v1/picking-orders/${pickingOrderId}/undo-in-review`, payload)
  return res.data
}
